module.exports = __webpack_public_path__ + "static/media/link.405b81bb.svg";